import { render, staticRenderFns } from "./SendsHistoryModal.vue?vue&type=template&id=2547eea4&scoped=true&"
import script from "./SendsHistoryModal.vue?vue&type=script&lang=js&"
export * from "./SendsHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./SendsHistoryModal.vue?vue&type=style&index=0&id=2547eea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2547eea4",
  null
  
)

export default component.exports